import { useSelector } from 'react-redux';

const Payment3DSecure = ({ children }) => {
	const { is3DSecureActive, html3DSecure } = useSelector(({ paymentReducer }) => paymentReducer);
	if (!is3DSecureActive) return children;
	window.sessionStorage.setItem('returnUrl', window.location.toString());
	// @ts-ignore
	document.open();
	// @ts-ignore
	document.write(html3DSecure);
	// @ts-ignore
	document.close();
	return null; //<div dangerouslySetInnerHTML={{ __html: html3DSecure }} />;
};

export default Payment3DSecure;
